import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8b8d8ea4&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=8b8d8ea4&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8d8ea4",
  null
  
)

export default component.exports